// src/components/VadesiYaklasanlar.js

// Dikkat: bu kartın veri kaynağı `workOrders.teslimTarihi` — yani ARAÇ TESLİM
// tarihidir, gerçek bir ödeme vadesi değil. Eski adı ("Vadesi Yaklaşanlar")
// personeli planlı taksitleri burada aramaya itiyordu; gerçek vade verisi
// `scheduledPayments` koleksiyonunda ve "Yaklaşan Taksitler" kartında.
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, where, onSnapshot, orderBy, limit } from 'firebase/firestore';
import { Paper, Typography, Box, Stack, Divider, CircularProgress, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { format, addDays, startOfDay } from 'date-fns';
import EventBusyIcon from '@mui/icons-material/EventBusy';

// Sorgu tavanı: dashboard'da hiçbir dinleyici sınırsız okumaz.
const SORGU_LIMITI = 60;
const LISTE_LIMITI = 6;

// YENİ: Dashboard'daki ile aynı formatlama fonksiyonu
const formatCurrency = (amount, finansGizli) => {
    if (finansGizli) return '**** ₺';
    return (amount || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
};

// GÜNCELLENDİ: 'finansGizli' prop'unu alıyor
const PaymentRow = ({ payment, finansGizli }) => (
    <MuiLink component={RouterLink} to={`/is-emri/${payment.id}`} sx={{ textDecoration: 'none' }}>
        <Paper 
            variant="outlined" 
            sx={{ 
                p: 1.5, 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                '&:hover': { backgroundColor: 'action.hover' },
                backgroundColor: '#fff' 
            }}
        >
            <Box>
                <Typography variant="body2" fontWeight="bold">{payment.musteriAdSoyad}</Typography>
                <Typography variant="caption" color="text.secondary">{payment.aracPlaka}</Typography>
            </Box>
            <Box textAlign="right">
                {/* GÜNCELLENDİ: formatCurrency fonksiyonunu kullanıyor */}
                <Typography color="error.main" fontWeight="bold">
                    {formatCurrency(payment.kalanTutar, finansGizli)}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    {payment.teslimTarihi?.toDate ? format(payment.teslimTarihi.toDate(), 'dd/MM/yyyy') : '-'}
                </Typography>
            </Box>
        </Paper>
    </MuiLink>
);

// GÜNCELLENDİ: 'finansGizli' prop'unu alıyor
const VadesiYaklasanlar = ({ finansGizli }) => {
    const [duePayments, setDuePayments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const today = startOfDay(new Date());
        const next7Days = addDays(today, 7);

        const q = query(collection(db, "workOrders"),
            where("kalanTutar", ">", 0),
            where("teslimTarihi", ">=", today),
            where("teslimTarihi", "<=", next7Days),
            orderBy("teslimTarihi", "asc"),
            limit(SORGU_LIMITI)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            setDuePayments(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setLoading(false);
        }, (error) => {
            console.error("Vadesi Yaklasanlar hatası:", error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    return (
        <Paper sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <EventBusyIcon color="warning" />
                <Typography variant="h6">
                    Teslimi Yaklaşanlar ({duePayments.length === SORGU_LIMITI ? `${SORGU_LIMITI}+` : duePayments.length})
                </Typography>
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 1 }}>
                7 gün içinde teslim edilecek, ödemesi tamamlanmamış iş emirleri
            </Typography>
            <Divider />
            <Stack spacing={1.5} sx={{ mt: 2, flexGrow: 1 }}>
                {loading ? (
                    <CircularProgress size={24} sx={{ mx: 'auto' }} />
                ) : duePayments.length > 0 ? (
                    <>
                        {duePayments.slice(0, LISTE_LIMITI).map(order => (
                            // GÜNCELLENDİ: 'finansGizli' prop'u PaymentRow'a iletiliyor
                            <PaymentRow key={order.id} payment={order} finansGizli={finansGizli} />
                        ))}
                        {duePayments.length > LISTE_LIMITI && (
                            <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'center' }}>
                                +{duePayments.length - LISTE_LIMITI} iş emri daha
                            </Typography>
                        )}
                    </>
                ) : (
                    <Typography color="text.secondary" sx={{ textAlign: 'center', pt: 2 }}>
                        7 gün içinde teslim edilecek ödemeli iş emri yok.
                    </Typography>
                )}
            </Stack>
        </Paper>
    );
};

export default VadesiYaklasanlar;